export interface Film {
  id: number;
  title: string;
  original: string;
  year: string;
  director: string;
  country: string;
  genres: string[];
  primaryGenre: string;
  rating: number;
  duration: string;
  tags: string[];
  blurb: string;
  poster: string;
  accent: string;
}

export const genreFilters = [
  "全部",
  "科幻",
  "动作",
  "剧情",
  "悬疑",
  "动画",
  "喜剧",
];

export const films: Film[] = [
  {
    id: 1,
    title: "沙丘2",
    original: "Dune: Part Two",
    year: "2024",
    director: "丹尼斯·维伦纽瓦",
    country: "美国",
    genres: ["科幻", "冒险", "史诗"],
    primaryGenre: "科幻",
    rating: 8.3,
    duration: "166 分钟",
    tags: ["视觉奇观", "IMAX", "年度期待"],
    blurb: "厄拉科斯的沙海之上，保罗踏上复仇与觉醒之路。宏大而细腻的科幻史诗，把“电影感”推到了新的高度。",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20lone%20figure%20walking%20across%20vast%20golden%20desert%20dunes%20under%20twin%20suns%2C%20giant%20sandworm%20silhouette%20in%20distance%2C%20warm%20amber%20and%20deep%20crimson%20color%20grade%2C%20dramatic%20epic%20movie%20poster%20illustration%2C%20soft%20grain%2C%20cinematic%20composition%2C%20high%20detail&width=600&height=860&seq=film-dune-1200&orientation=portrait",
    accent: "accent",
  },
  {
    id: 2,
    title: "奥本海默",
    original: "Oppenheimer",
    year: "2023",
    director: "克里斯托弗·诺兰",
    country: "美国",
    genres: ["剧情", "传记", "历史"],
    primaryGenre: "剧情",
    rating: 8.8,
    duration: "180 分钟",
    tags: ["人物传记", "诺兰", "冲奥之作"],
    blurb: "原子弹之父的荣耀与深渊。诺兰用交错的时间线，讲述一个天才如何在时代洪流与良知之间挣扎。",
    poster: "https://readdy.ai/api/search-image?query=Atmospheric%20biographical%20movie%20key%20art%20portrait%20of%20a%20brooding%20professor%20silhouette%20against%20an%20explosive%20fiery%20orange%20sky%2C%20mushroom%20cloud%20glow%2C%20warm%20ember%20and%20dark%20sepia%20tone%2C%20grainy%20film%20texture%2C%20cinematic%20dramatic%20poster%20illustration%2C%20high%20detail&width=600&height=860&seq=film-oppen-1123&orientation=portrait",
    accent: "primary",
  },
  {
    id: 3,
    title: "流浪地球2",
    original: "The Wandering Earth II",
    year: "2023",
    director: "郭帆",
    country: "中国",
    genres: ["科幻", "灾难", "冒险"],
    primaryGenre: "科幻",
    rating: 8.3,
    duration: "173 分钟",
    tags: ["国产科幻", "大制作", "硬核"],
    blurb: "在太阳危机来临之前，人类启动“移山计划”。国产科幻工业的里程碑，家国叙事与硬核想象的结合体。",
    poster: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20key%20art%20of%20earth%20moving%20through%20deep%20space%20with%20glowing%20blue%20planetary%20engines%20and%20massive%20space%20stations%2C%20cold%20steel%20blue%20and%20warm%20amber%20accents%2C%20huge%20scale%20cinematic%20poster%20illustration%2C%20detailed%2C%20dramatic%20lighting&width=600&height=860&seq=film-wandering-2311&orientation=portrait",
    accent: "secondary",
  },
  {
    id: 4,
    title: "蜘蛛侠：纵横宇宙",
    original: "Spider-Man: Across the Spider-Verse",
    year: "2023",
    director: "华金·多斯·桑托斯",
    country: "美国",
    genres: ["动画", "动作", "科幻"],
    primaryGenre: "动画",
    rating: 8.6,
    duration: "140 分钟",
    tags: ["视觉革命", "多元宇宙", "口碑神作"],
    blurb: "色彩爆炸的多元宇宙冒险。把动画叙事的美学边界彻底打开，每一帧都是值得暂停的艺术品。",
    poster: "https://readdy.ai/api/search-image?query=Vibrant%20comic%20book%20style%20animated%20movie%20poster%20art%20of%20a%20colorful%20spider%20hero%20leaping%20between%20fractured%20neon%20dimensions%2C%20bold%20red%20and%20cyan%20and%20gold%20comic%20dot%20halftone%20texture%2C%20energetic%20dynamic%20composition%2C%20stylized%20illustration&width=600&height=860&seq=film-spider-4567&orientation=portrait",
    accent: "accent",
  },
  {
    id: 5,
    title: "封神第一部：朝歌风云",
    original: "Creation of the Gods I",
    year: "2023",
    director: "乌尔善",
    country: "中国",
    genres: ["动作", "史诗", "奇幻"],
    primaryGenre: "动作",
    rating: 7.8,
    duration: "148 分钟",
    tags: ["中国神话", "大场面", "封神宇宙"],
    blurb: "封神榜重启之作。朝歌的钟声敲响，少年质子们在权谋与神魔之间走向各自的命运。",
    poster: "https://readdy.ai/api/search-image?query=Majestic%20Chinese%20mythology%20epic%20movie%20poster%20art%20of%20ancient%20warriors%20in%20armor%20before%20a%20grand%20bronze%20crimson%20palace%20with%20soaring%20phoenix%20and%20thunder%20clouds%2C%20rich%20red%20and%20gold%20imperial%20tones%2C%20dramatic%20cinematic%20illustration%2C%20detailed&width=600&height=860&seq=film-fengshen-8890&orientation=portrait",
    accent: "primary",
  },
  {
    id: 6,
    title: "周处除三害",
    original: "The Pig, the Snake and the Pigeon",
    year: "2024",
    director: "黄精甫",
    country: "中国台湾",
    genres: ["动作", "悬疑", "犯罪"],
    primaryGenre: "动作",
    rating: 8.1,
    duration: "134 分钟",
    tags: ["黑马之作", "酣畅淋漓", "黑色幽默"],
    blurb: "通缉犯榜单上的亡命之徒，决定以“除掉前两名”来证明自己的价值。一部爽感与反思并存的黑色寓言。",
    poster: "https://readdy.ai/api/search-image?query=Noir%20action%20crime%20movie%20key%20art%20portrait%20of%20a%20ruthless%20man%20in%20a%20dark%20trench%20coat%20under%20harsh%20neon%20and%20warm%20incense%20lighting%2C%20moody%20crimson%20and%20teal%20shadows%2C%20gritty%20cinematic%20poster%20illustration%2C%20film%20grain&width=600&height=860&seq=film-zhou-3345&orientation=portrait",
    accent: "accent",
  },
  {
    id: 7,
    title: "孤注一掷",
    original: "No More Bets",
    year: "2023",
    director: "申奥",
    country: "中国",
    genres: ["剧情", "犯罪", "悬疑"],
    primaryGenre: "剧情",
    rating: 7.1,
    duration: "130 分钟",
    tags: ["反诈题材", "真实感", "话题之作"],
    blurb: "一部把境外诈骗黑幕搬上银幕的现实题材电影，让无数观众重新审视“天上掉馅饼”的诱惑。",
    poster: "https://readdy.ai/api/search-image?query=Dark%20thriller%20drama%20movie%20poster%20art%20of%20a%20crouching%20figure%20in%20a%20dim%20backlit%20office%20with%20rows%20of%20computer%20screens%20glowing%2C%20tense%20claustrophobic%20mood%2C%20muted%20warm%20and%20cold%20contrast%2C%20gritty%20cinematic%20illustration%2C%20high%20detail&width=600&height=860&seq=film-gu-2210&orientation=portrait",
    accent: "secondary",
  },
  {
    id: 8,
    title: "长安三万里",
    original: "Chang An",
    year: "2023",
    director: "谢君伟",
    country: "中国",
    genres: ["动画", "历史", "剧情"],
    primaryGenre: "动画",
    rating: 8.3,
    duration: "168 分钟",
    tags: ["大唐", "诗人李白", "国风动画"],
    blurb: "从高适的视角回望李白的一生，也回望大唐由盛转衰的几十年。一场写给中文的诗意长卷。",
    poster: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20ink%20painting%20style%20animated%20movie%20poster%20art%20of%20a%20Tang%20dynasty%20poet%20in%20flowing%20robes%20gazing%20at%20the%20moon%20over%20misty%20mountains%20and%20ancient%20city%20walls%2C%20ink%20wash%20warm%20gold%20and%20jade%20green%20tones%2C%20refined%20traditional%20aesthetic&width=600&height=860&seq=film-changan-7788&orientation=portrait",
    accent: "accent",
  },
  {
    id: 9,
    title: "河边的错误",
    original: "Only the River Flows",
    year: "2023",
    director: "魏书钧",
    country: "中国",
    genres: ["悬疑", "剧情"],
    primaryGenre: "悬疑",
    rating: 7.2,
    duration: "101 分钟",
    tags: ["余华改编", "迷离质感", "先锋叙事"],
    blurb: "改编自余华同名小说。一桩河边命案，抽丝剥茧的调查让刑警陷入真假难辨的迷宫。",
    poster: "https://readdy.ai/api/search-image?query=Melancholy%20Chinese%20mystery%20movie%20poster%20art%20of%20a%20solitary%20detective%20silhouette%20by%20a%20misty%20riverside%20at%20dusk%2C%20foggy%20willow%20trees%2C%20muted%20olive%20and%20warm%20gray%20washed%20tones%2C%20noir%20atmosphere%2C%20cinematic%20illustration%2C%20textured&width=600&height=860&seq=film-river-9901&orientation=portrait",
    accent: "primary",
  },
  {
    id: 10,
    title: "坠落的审判",
    original: "Anatomy of a Fall",
    year: "2024",
    director: "茹斯汀·特里耶",
    country: "法国",
    genres: ["剧情", "悬疑"],
    primaryGenre: "剧情",
    rating: 8.4,
    duration: "151 分钟",
    tags: ["金棕榈", "法庭片", "婚姻剖析"],
    blurb: "丈夫坠楼身亡，妻子成为唯一嫌疑人。一场审判不仅审视案件，也把一段婚姻的裂痕剖开给人看。",
    poster: "https://readdy.ai/api/search-image?query=Restrained%20European%20drama%20movie%20poster%20art%20of%20a%20woman%20standing%20in%20a%20bright%20snowy%20alpine%20landscape%20beside%20a%20modern%20chalet%2C%20cold%20muted%20palette%20with%20warm%20flesh%20tone%20accent%2C%20minimal%20composition%2C%20thoughtful%20contemplative%20mood%2C%20cinematic&width=600&height=860&seq=film-fall-5678&orientation=portrait",
    accent: "secondary",
  },
  {
    id: 11,
    title: "芭比",
    original: "Barbie",
    year: "2023",
    director: "格蕾塔·葛韦格",
    country: "美国",
    genres: ["喜剧", "奇幻", "冒险"],
    primaryGenre: "喜剧",
    rating: 8.0,
    duration: "114 分钟",
    tags: ["粉色风暴", "高概念", "现象级"],
    blurb: "当芭比从芭比乐园走进现实世界，一场关于自我、性别与存在的粉色哲学冒险就此展开。",
    poster: "https://readdy.ai/api/search-image?query=Playful%20vibrant%20comedy%20movie%20poster%20art%20of%20a%20blonde%20character%20in%20bright%20pink%20holding%20a%20star%20shaped%20sunglasses%2C%20hot%20pink%20and%20fuchsia%20dramatic%20lighting%2C%20glossy%20stylish%2C%20fashionable%20cinematic%20illustration%2C%20high%20contrast&width=600&height=860&seq=film-barbie-3347&orientation=portrait",
    accent: "accent",
  },
  {
    id: 12,
    title: "热辣滚烫",
    original: "YOLO",
    year: "2024",
    director: "贾玲",
    country: "中国",
    genres: ["喜剧", "剧情"],
    primaryGenre: "喜剧",
    rating: 6.9,
    duration: "129 分钟",
    tags: ["励志", "逆袭", "拳击"],
    blurb: "一个“讨好型”女孩决定为自己活一次。热血、疼痛又真诚的逆袭故事，看完想立刻开始改变。",
    poster: "https://readdy.ai/api/search-image?query=Inspiring%20underdog%20comedy%20drama%20movie%20poster%20art%20of%20a%20determined%20woman%20boxer%20with%20boxing%20gloves%20in%20a%20gym%2C%20warm%20amber%20arena%20lighting%2C%20sweat%20and%20glow%2C%20motivational%20energetic%20mood%2C%20cinematic%20illustration%2C%20dynamic&width=600&height=860&seq=film-yolo-1209&orientation=portrait",
    accent: "primary",
  },
];